import { render } from "./CustomerReportsTable.vue?vue&type=template&id=b41593c6&scoped=true"
import script from "./CustomerReportsTable.vue?vue&type=script&lang=js"
export * from "./CustomerReportsTable.vue?vue&type=script&lang=js"

import "./CustomerReportsTable.vue?vue&type=style&index=0&id=b41593c6&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41593c6"]])

export default __exports__